import { sortSessionsForDayDisplay } from '@/pages/professional/home/utils/calendarLogic';

export interface SessionGroup {
	label: string;
	dateValue: number; // Usado para ordenar os blocos de dias
	sessions: Sessions.Session[];
}

export const groupSessionsByDate = (
	sessions: Sessions.Session[],
	now: Date = new Date(),
): SessionGroup[] => {
	const groupsMap: Record<string, SessionGroup> = {};

	sessions.forEach((session) => {
		const date = new Date(session.selected_date);
		const today = new Date();

		// Formato DD/MM
		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0');
		let label = `${day}/${month}`;

		if (date.toDateString() === today.toDateString()) {
			label = 'Hoje';
		}

		// Criamos um valor numérico do início do dia para ordenação dos blocos
		const startOfDay = new Date(
			date.getFullYear(),
			date.getMonth(),
			date.getDate(),
		).getTime();

		if (!groupsMap[label]) {
			groupsMap[label] = {
				label,
				dateValue: startOfDay,
				sessions: [],
			};
		}
		groupsMap[label].sessions.push(session);
	});

	// 1. Transforma em array e ordena os DIAS (Mais recente primeiro)
	const sortedGroups = Object.values(groupsMap).sort(
		(a, b) => b.dateValue - a.dateValue,
	);

	// 2. Em andamento → futuras → passadas; dentro de cada grupo, por horário
	sortedGroups.forEach((group) => {
		group.sessions = sortSessionsForDayDisplay(group.sessions, now);
	});

	return sortedGroups;
};
